import React, {useState} from 'react';
import {useControllerProps} from '../../../ControllerContext';
import {Text, TextButton, TextPriority} from '@wix/wix-ui-tpa/cssVars';
import {ChevronDown, ChevronUp} from '@wix/wix-ui-icons-common/on-stage';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {classes} from './Subscriptions.st.css';
import {TotalsSectionDataHook} from '../TotalsSection';
import {useLocaleKeys} from '../../../../LocaleKeysProvider';

const VISIBLE_LINES = 2;

export function Subscriptions() {
  const {subscriptionsProjections} = useControllerProps().thankYouPageStore;

  if (!subscriptionsProjections.length) {
    return null;
  }

  const visibleProjections = subscriptionsProjections.slice(0, VISIBLE_LINES);
  const collapsedProjections = subscriptionsProjections.slice(VISIBLE_LINES);

  return (
    <div className={classes.projectionsContainer}>
      {visibleProjections.map((projection, i) => (
        <Projection key={i} projection={projection} descriptionOnly={subscriptionsProjections.length === 1} />
      ))}
      {!!collapsedProjections.length && (
        <Collapse>
          {collapsedProjections.map((projection, i) => (
            <Projection key={i} projection={projection} />
          ))}
        </Collapse>
      )}
    </div>
  );
}

function Collapse({children}: {children: React.ReactNode}) {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const chevron = isOpen ? <ChevronUp /> : <ChevronDown />;
  const toggleText = isOpen
    ? t('thankYouPage.totals.subscriptions.showLess')
    : t('thankYouPage.totals.subscriptions.showMore');

  return (
    <>
      {isOpen && <div>{children}</div>}
      <TextButton
        onClick={() => setIsOpen(!isOpen)}
        className={classes.projectionText}
        data-hook={TotalsSectionDataHook.subscriptionProjectionToggle}>
        <div className={classes.toggleButton}>
          {toggleText}
          {chevron}
        </div>
      </TextButton>
    </>
  );
}

function Projection({
  projection,
  descriptionOnly = false,
}: {
  descriptionOnly?: boolean;
  projection: {itemName: string; chargesDescription: string};
}) {
  const localeKeys = useLocaleKeys();
  return (
    <Text
      data-hook={TotalsSectionDataHook.subscriptionProjection}
      priority={TextPriority.secondary}
      className={classes.projectionText}>
      {descriptionOnly
        ? projection.chargesDescription
        : localeKeys.thankYouPage.totals.subscriptions.pricingPlanProjection({
            ...projection,
            // @ts-expect-error: titk@wix.com - Typed locale keys not fully mimic the typedef of TFunction which also has this flag as part of TOptionsBase interface
            interpolation: {escapeValue: false},
          })}
    </Text>
  );
}
